import React, { ReactNode } from 'react'

interface ICodeProps {
  children: ReactNode
}

export const Code = (props: ICodeProps) => {
  return <p className="ly-leave__code">Code : {props.children}</p>
}
